import { Helmet } from 'react-helmet';
import React, { useEffect } from 'react';
import './App.css';
import AppRouters from './Components/Navbar/Routers/AppRouters';
import ReactGa from 'react-ga';
import logo from './Assets/Images/logo/stella-logo.png';



const GAcode = process.env.REACT_APP_GACODE;

const App = () => {
  useEffect(() => {
    ReactGa.initialize(GAcode);
    // TO REPORT PAGE VIEW
    ReactGa.pageview(window.location.pathname + window.location.search);
    // console.log('App', window.location.pathname + window.location.search);
  }, []);

  return (
    <>
      <Helmet>
         <header>
      <img src={logo} alt="Stella Art Logo" className="logo" />
    </header>
        
        <meta
          name="Fine Art"
          content="Fine art painting can be a portrait or ourdoor painting (plein air) and commision painting anything of your interest."
        />
        <meta
          name="Commission painting"
          content="Fine art painting can be a portrait or ourdoor painting (plein air) and commision painting anything of your interest."
        />
        <meta name="Commission painting" content="Commission painting" />
      </Helmet>
      <AppRouters />
    </>
  );
};
export default App;